import { FormEvent } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'
import { TdsField } from '@trv-tds/react'

import type { ClaimHandlerType } from '../claim/types'
import type { GlobalState } from '../types'
import { uploadSelectHandler } from './upload-actions'
import { getClaimHandlers } from './upload-selectors'


type ClaimHandlerSelectProps = {
  claimHandlers: ClaimHandlerType[]
  requesting: boolean
  handler: string
  onSelectHandler(arg: string): void
}

const ClaimHandlerSelectComponent = (props: ClaimHandlerSelectProps) => {
  const { claimHandlers, requesting, handler, onSelectHandler } = props

  const handleHandlerChange = (event: FormEvent<HTMLSelectElement>) => {
    if (!event.currentTarget.value) {
      return
    }
    onSelectHandler(event.currentTarget.value)
  }

  if (claimHandlers.length === 0) {
    return <></>
  }

  return (
    <TdsField label='Recipient' style={{ width: '50%' }}>
      <select
        name='Recipient'
        id='claimHandlerSelection'
        onChange={handleHandlerChange}
        disabled={requesting}
        value={handler}
      >
        <option value="">Select Option</option>
        { claimHandlers.map((claimhandler, index) =>
          <option key={index} value={claimhandler.contactUId}>
            {claimhandler.name.toLowerCase()}
          </option>
        )}
        <option value='other'>Unknown/Not Listed</option>
      </select>
    </TdsField>
  )
}

const mapStateToProps = (state: GlobalState) => ({
  claimHandlers: getClaimHandlers(state),
  requesting: state.upload.requesting,
  handler: state.upload.handler
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSelectHandler: (handler: string) => dispatch(uploadSelectHandler(handler))
})

const ClaimHandlerSelect = connect(mapStateToProps, mapDispatchToProps)(ClaimHandlerSelectComponent)

export {
  ClaimHandlerSelect,
  ClaimHandlerSelectComponent // for testing without connect
}
